export const GET_AUTH_TOKEN    = "GET_AUTH_TOKEN";
export const GET_AUTH_KEY      = "GET_AUTH_KEY";
